import { Box } from "@vp/swan";
import React, { ReactNode, useEffect, useState } from "react";

import useMounted from "../../hooks/useMounted";
import PriceLoading from "../PriceLoading";

type CSRWrapperProps = {
  children: ReactNode;
};

const CSRWrapper = ({ children }: CSRWrapperProps) => {
  const isMounted = useMounted();
  const [uniqueID, setUniqueID] = useState<number | null>(null);

  useEffect(() => {
    setUniqueID(Math.random());
  }, [isMounted]);

  if (!isMounted) return (<PriceLoading />); // SSR fallback

  return <Box key={`price-platform-${uniqueID}`}>{children}</Box>;
};

export default CSRWrapper;
